<!-- Breadcrumb -->
<div class="flex-align-center">
  <div class="card-breadcrumb">

    <span class="breadcrumb" pTooltip="{{'campaign.home' | translate}}" tooltipPosition="bottom">
    <i class="fa fa-home"
   (click)="onClickHome()"
   class="fa fa-home"
   pTooltip="{{'campaign.home' | translate}}"
   tooltipPosition="bottom">
</i>
    </span>
    
    <span *ngFor="let breadcrumb of arrayBreadcrumbs;let i=index;" class="breadcrumb breadcrumb-menu">
      <i class="fa fa-chevron-right chevron"></i>
      <span [ngClass]="{'breadCrumbLast': i == (arrayBreadcrumbs.length-1) }" (click)="onClick(breadcrumb)">{{breadcrumb.description}}</span>
    </span>

    <div class="campaignType" *ngIf="campaignTypeName && campaignTypeDescription">
      <b>{{campaignTypeName}}</b> {{campaignTypeDescription}}
    </div>

    <div class="clear_fix"></div>

  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/campaign-3-breadcrumb/campaign-3-breadcrumb.component.html